import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'chat',
})
export class ChatPipe implements PipeTransform {
    transform(link: string, style: string): string {
        return this.processMessage(link, style);
    }

    private processMessage(plainText: string, style: string): string {
        let replacedText;

        // URLs starting with http://, https://, or ftp://
        const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = plainText.replaceAll(replacePattern1, '<a href="$1" class="' + style + '" target="_blank">$1</a>');

        // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replaceAll(replacePattern2, '$1<a href="http://$2" class="' + style + '" target="_blank">$2</a>');

        const replacePattern3 = /(([a-zA-Z0-9\-_.)])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replaceAll(replacePattern3, '<a href="mailto:$1" class="' + style + '">$1</a>');

        // replace linebreaks with BR
        replacedText = replacedText.replaceAll(/(\r\n|\r|\n)/g, '<br>');
        return replacedText;
    }
}
